import { ILookupType } from '../common/defaults';
import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import * as LookupActionTypes from './types';

export const getLookupTypes = (url: string) => {
  return async (dispatch) => {
    try {
      Api.get(url)
        //.then((res: ApiResponse<any>))
        .then((result: ApiResponse<any>) => {
          //console.log(result);
          let nameValuePairArray = result.data.map((x) => {
            return { name: x, value: x };
          });
          dispatch(reduceLookupTypes(nameValuePairArray));
        });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const getAllTypes = (url: string) => {
  return async (dispatch) => {
    try {
      await fetch(url)
        .then((res) => res.json())
        .then((result) => {
          dispatch(saveAllTypesToStore(result));
        });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const getActiveTypes = (url: string) => {
  return async (dispatch) => {
    try {
      await fetch(url)
        .then((res) => res.json())
        .then((result) => {
          dispatch(saveActiveTypesToStore(result));
        });
    } catch (ex) {
      console.log(ex);
    }
  };
};
export const saveActiveTypesToStore = (types: ILookupType[]) => {
  return {
    type: LookupActionTypes.GET_ACTIVE_TYPES,
    value: types,
  };
};

export const reduceLookupTypes = (lookupTypes: ILookupType[]) => {
  return {
    type: LookupActionTypes.GET_LOOKUP_TYPES,
    value: lookupTypes,
  };
};

export const saveAllTypesToStore = (types: ILookupType[]) => {
  return {
    type: LookupActionTypes.GET_ALL_TYPES,
    value: types,
  };
};

export const loadTypesByName = (types: ILookupType[]) => {
  return {
    type: LookupActionTypes.GET_TYPE_BY_NAME,
    value: types,
  };
};

export const getLookupsByType = (url: string, type: string) => {
  return async (dispatch) => {
    if (type === '-1') dispatch(reduceLookups([]));
    else {
      try {
        await Api.get(url + '?name=' + type).then((res: ApiResponse<any>) => {
          dispatch(reduceLookups(res.data));
        });
      } catch (ex) {
        console.log(ex);
      }
    }
  };
};

export const getTypesByName = (url: string, name: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url + '?name=' + name).then((res: ApiResponse<any>) => {
        dispatch(loadTypesByName(res.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const reduceLookups = (lookups: ILookupType[]) => {
  return {
    type: LookupActionTypes.GET_LOOKUPS_BY_TYPE,
    value: lookups,
  };
};

export const saveLookup = (url: string, lookup: ILookupType, type: string) => {
  return async (dispatch) => {
    try {
      Api.post(url, { entity: lookup, typeName: type }).then(
        (result: ApiResponse<any>) => {
          dispatch(reduceLookups(result.data));
        }
      );
    } catch (ex) {
      console.log(ex);
    }
  };
};
